//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Fuse from 'fuse.js/dist/fuse.basic.common';

export default {
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selection: null,
            filteredData: this.data,
            fuseSearch: new Fuse(this.data, {
                threshold: 0.2,
                includeScore: true,
                ignoreLocation: true,
                keys: [
                    { name: 'markenName', weight: 10 },
                    { name: 'blz', weight: 5 },
                    { name: 'ort', weight: 2 },
                    { name: 'bic', weight: 1 },
                ],
            }),
        };
    },
    computed: {
        options() {
            return this.filteredData.map((entry) => ({
                label: `${entry.markenName} (${entry.blz})`,
                value: entry,
            }));
        },
    },
    methods: {
        filter(input, update) {
            if (input === '') {
                update(() => {
                    this.filteredData = this.data;
                });
            } else {
                update(() => {
                    this.filteredData = this.fuseSearch.search(input).map((result) => result.item);
                });
            }
        },
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        async ok() {
            if (!this.$refs['bank-chooser-select'].validate() || !this.selection) {
                return;
            }

            this.$emit('ok', this.selection.value);
            this.hide();
        },
        cancel() {
            this.hide();
        },
    },
};
